export enum ControlResult {
    NO_RESERVATIONS = 0,
    MINOR_RESERVATIONS = 1,
    MAJOR_RESERVATIONS = 2,
    CANCELLED = 3
}

export const ControlResultLabels = {
    [ControlResult.NO_RESERVATIONS]: 'Bez zastrzeżeń',
    [ControlResult.MINOR_RESERVATIONS]: 'Z nieistotnymi zastrzeżeniami',
    [ControlResult.MAJOR_RESERVATIONS]: 'Z istotnymi zastrzeżeniami',
    [ControlResult.CANCELLED]: 'Kontrola anulowana'
};

export const getControlResultLabel = (result: number | null | undefined): string => {
    if (result === null || result === undefined) {
        return '';
    }
    return ControlResultLabels[result as ControlResult] || '';
};